export default __webpack_public_path__ + "static/media/IMG_5384.9c9b6499.WEBP";